import { implementCustomExpressions } from '../__generated/implementation.js';
import { CircularHole, CornerFixingHoles, CountersinkHole, KickPlateFixingHoles } from '../__generated/model/index.js';
import { createCircularHolePolygon } from '../polygons/circular-hole.js';
import { createCountersinkHolePolygon } from '../polygons/countersink-hole.js';
import { createMultipleHolePolygons } from '../polygons/multple-fixing-holes.js';
const sizeTolerance = {
    x: 0,
    y: 0
};
export const circularHoleExpressions = implementCustomExpressions({
    CircularHole: {
        $sizeX: (self)=>2 * self.radius,
        $sizeY: (self)=>2 * self.radius,
        $innerSize: (self)=>2 * self.radius,
        $sizeTolerance: ()=>sizeTolerance,
        $polygons: (self)=>{
            if (CornerFixingHoles.is(self)) {
                return createMultipleHolePolygons(self, self.$plate, {
                    horizontal: 4
                });
            } else if (KickPlateFixingHoles.is(self)) {
                return createMultipleHolePolygons(self, self.$plate, {
                    horizontal: self.$horizontalCount,
                    vertical: self.$verticalCount
                });
            } else if (CircularHole.is(self)) {
                return [
                    createCircularHolePolygon(self)
                ];
            } else if (CountersinkHole.is(self)) {
                return [
                    createCountersinkHolePolygon(self)
                ];
            }
            return [];
        }
    }
});

//# sourceMappingURL=circular-hole.js.map